var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('services-cart',{staticClass:"license-buy",on:{"update-pay-info":_vm.updatePayInfo},model:{value:(_vm.payMethods),callback:function ($$v) {_vm.payMethods=$$v},expression:"payMethods"}})}
var staticRenderFns = []

export { render, staticRenderFns }